<p class="modal-title">Admin: Create Trivia Rain</p>
<div class="body flex flex-col">
  <form
    [formGroup]="triviaRainForm"
    (ngSubmit)="onSubmit()"
    #triviaRainFormRef="ngForm"
  >
    <app-form-field
      [label]="'Question'"
      [formControl]="question"
      [errorType]="'outline'"
      [id]="'question'"
      [placeholder]="'Enter Question...'"
      [error]="
        !question.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      class="correct"
      [label]="'Correct Answer'"
      [formControl]="correctAnswer"
      [errorType]="'outline'"
      [id]="'correctAnswer'"
      [placeholder]="'Enter Correct Answer...'"
      [error]="
        !correctAnswer.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      [label]="'Answer 2'"
      [formControl]="answer2"
      [errorType]="'outline'"
      [id]="'answer2'"
      [placeholder]="'Enter Answer 2...'"
      [error]="
        !answer2.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      [label]="'Answer 3'"
      [formControl]="answer3"
      [errorType]="'outline'"
      [id]="'answer3'"
      [placeholder]="'Enter Answer 3...'"
      [error]="
        !answer3.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      [label]="'Answer 4'"
      [formControl]="answer4"
      [errorType]="'outline'"
      [id]="'answer4'"
      [placeholder]="'Enter Answer 4...'"
      [error]="
        !answer4.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      [label]="'Reward'"
      [formControl]="reward"
      [errorType]="'outline'"
      [id]="'reward'"
      [placeholder]="'Enter Reward...'"
      [error]="
        !reward.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />

    <button class="button button--style-yellow h-32 padding-x-12" type="submit">
      Create Trivia Rain
    </button>
  </form>
</div>
